import React from 'react';
import styled from 'styled-components';
import { modsyLogoClicked } from 'web-ui-kit/events';

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _templateObject;

var STYLE_VARIANTS = {
  "default": {
    width: '127px'
  },
  big: {
    width: '175px'
  },
  small: {
    width: '90px'
  }
};

function ModsyLogo(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$dispatch = _ref.dispatch,
      dispatch = _ref$dispatch === void 0 ? function () {} : _ref$dispatch,
      _ref$margin = _ref.margin,
      margin = _ref$margin === void 0 ? 0 : _ref$margin,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? '' : _ref$variant,
      _ref$linkComponent = _ref.linkComponent,
      linkComponent = _ref$linkComponent === void 0 ? function (_ref2) {
    var children = _ref2.children;
    return (
      /*#__PURE__*/
      React.createElement("a", null, children)
    );
  } : _ref$linkComponent,
      _ref$modsyButtonConfi = _ref.modsyButtonConfig,
      modsyButtonConfig = _ref$modsyButtonConfi === void 0 ? {
    destination: '',
    app: '',
    href: '',
    as: ''
  } : _ref$modsyButtonConfi;
  var LinkComponent = linkComponent;
  var calculatedWidth = variant ? STYLE_VARIANTS[variant]['width'] : STYLE_VARIANTS["default"].width;
  return (
    /*#__PURE__*/
    React.createElement(LinkComponent, {
      route: modsyButtonConfig,
      styledLink: StyledLink
    },
    /*#__PURE__*/
    React.createElement("svg", {
      role: "img",
      className: className,
      style: {
        cursor: 'pointer',
        margin: margin
      },
      viewBox: "0 0 127 23",
      width: calculatedWidth,
      height: 30,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "data-testid": "modsy-logo",
      "aria-labelledby": "modsy-logo-title-".concat(variant, " modsy-logo-desc-").concat(variant),
      onClick: function onClick(event) {
        return dispatch({
          type: modsyLogoClicked,
          payload: {
            event: event
          }
        });
      }
    },
    /*#__PURE__*/
    React.createElement("title", {
      id: "modsy-logo-title-".concat(variant)
    }, "Go to modsy homepage"),
    /*#__PURE__*/
    React.createElement("desc", {
      id: "modsy-logo-desc-".concat(variant)
    }, "Logo to redirect to modsy homepage"),
    /*#__PURE__*/
    React.createElement("path", {
      d: "M31.9692 0.939392H32.2875L41.6939 11.9556L51.013 0.939392H51.3313V20.8559H48.408V10.6237C48.408 9.55161 48.5235 7.87026 48.5235 7.81122C48.4669 7.87026 47.5404 9.28949 46.7577 10.1585L41.8094 16.1306H41.4628L36.5121 10.1585C35.7884 9.31783 34.8619 7.92693 34.777 7.81122C34.777 7.87026 34.8925 9.55161 34.8925 10.6237V20.8583H31.9692V0.939392Z",
      fill: "black"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      d: "M54.2856 10.9988C54.2856 5.11409 58.8002 0.880005 64.444 0.880005C70.0596 0.880005 74.5741 5.11173 74.5741 10.9988C74.5741 16.8836 70.0596 21.1177 64.444 21.1177C58.8002 21.1177 54.2856 16.8859 54.2856 10.9988ZM71.4481 10.9988C71.4481 6.79545 68.5531 3.63582 64.444 3.63582C60.3349 3.63582 57.4117 6.79545 57.4117 10.9988C57.4117 15.2022 60.3349 18.3618 64.444 18.3618C68.5531 18.3618 71.4481 15.2046 71.4481 10.9988Z",
      fill: "black"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      d: "M77.6011 1.14209H83.0139C89.3225 1.14209 93.5188 5.08572 93.5188 10.9988C93.5188 16.9142 89.3508 20.8555 83.0139 20.8555H77.6011V1.14209ZM82.8111 18.1611C87.9339 18.1611 90.3362 15.2045 90.3362 11.0012C90.3362 6.79777 87.9339 3.84123 82.8111 3.84123H80.6705V18.1611H82.8111Z",
      fill: "black"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      d: "M95.0933 17.0301L97.6111 15.6392C98.5375 17.1765 99.7234 18.3926 102.126 18.3926C104.122 18.3926 105.542 17.3205 105.542 15.6958C105.542 13.9861 104.384 13.2328 102.241 12.2741L100.94 11.6955C98.0755 10.4203 96.338 8.97041 96.338 5.92649C96.338 2.99829 98.5941 0.910767 101.866 0.910767C104.471 0.910767 106.237 1.89785 107.423 4.01372L105.021 5.49199C104.269 4.1861 103.399 3.57921 101.866 3.57921C100.303 3.57921 99.3202 4.5356 99.3202 5.86982C99.3202 7.34809 100.159 8.01402 102.156 8.8854L103.429 9.46631C106.786 10.9446 108.58 12.5102 108.58 15.6699C108.58 19.1199 105.888 21.1201 102.185 21.1201C98.4503 21.1177 96.1919 19.2616 95.0933 17.0301Z",
      fill: "black"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      d: "M116.393 13.6389L109.533 1.14441H112.977L116.768 8.24766C117.318 9.31976 117.954 11.0602 117.954 11.0602C117.954 11.0602 118.591 9.35046 119.14 8.24766L122.846 1.14441H126L119.461 13.4358V20.8578H116.393V13.6389Z",
      fill: "black"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      d: "M12.1689 5.52501V11.0191L17.6689 5.49409V0L12.1689 5.52501Z",
      fill: "#ECBC13"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      d: "M17.6689 0V5.49409L20.4249 8.26254L23.1689 5.525L17.6689 0Z",
      fill: "#415B82"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      d: "M23.1689 5.5249L12.1689 16.5059V22L23.1689 11.019V11.0166V5.5249Z",
      fill: "#698CCF"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      d: "M12.1689 5.52501V11.0191L6.66895 5.49409V0L12.1689 5.52501Z",
      fill: "#0E7065"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      d: "M6.66891 0.000183105V5.49427L3.91294 8.26272L1.16895 5.52519L6.66891 0.000183105Z",
      fill: "#EB9494"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      d: "M1.16895 5.5249L12.1689 16.5059V22L1.16895 11.019V11.0166V5.5249Z",
      fill: "#A84C58"
    })))
  );
}

var StyledLink = styled.a(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n"])));
export default ModsyLogo;